import { Citation, H1, H2, H3, Text } from '../ui/typography';
import PageSeo from '../seo/PageSeo';
import { localBusinessSchema, personSchema } from '../seo/schema';

function About() {
  return (
    <>
      <PageSeo
        title="Psihoterapevtka Ljubljana | Špela Verbnik"
        description="Psihoterapevtka in psihologinja Špela Verbnik. Psihoterapija in psihološko svetovanje v Ljubljani — za odrasle, otroke, mladostnike, pare in družine."
        path="/"
        jsonLd={[localBusinessSchema, personSchema]}
      />
      <div className='bg-primaryBg pl-4 pr-4'>
        <div className="lg:w-1/2 m-auto flex flex-col items-center align-middle pt-12 pb-6" >
          <H1 style={{color: "#616287"}} className="lg:text-3xl">Psihoterapija in psihološko svetovanje v Ljubljani</H1>
          <div className='flex flex-col lg:flex-row lg:items-start w-full '>
            <div className='flex-1 relative lg:pr-12 pt-12'>
              <img
                src="/assets/photo_scaled_x_y.jpg"
                alt="Špela Verbnik, psihoterapevtka in psihologinja v Ljubljani"
                className="block w-full max-w-full h-auto mx-auto"
              />
            </div>
            <div className='flex flex-1 pb-24'>
              <div className='flex flex-col w-full'>
                <Text className="text-lg font-bold pt-12 text-left">
                  Špela Verbnik, mag. psihologije, certificirana sistemska psihoterapevtka
                </Text>
                <Text className=" pt-6 text-center text-justify">
                  Biti psihoterapevtka in psihologinja je zame privilegij in velika odgovornost. 
                </Text>
                <Text className=" pt-6 text-center text-justify">Moja pot v ta poklic se je začela z radovednostjo do notranjih svetov in tu sem našla svoje poslanstvo. Skozi lastne izkušnje, v prepletu različnih vlog: hčerke, partnerke, mame in prijateljice, sem spoznala, da se pot do drugih začne znotraj nas. Zavezanost temu spoznanju in želja, da bi ga resnično živela, sta me usmerili v večletni proces lastne psihoterapije, ki predstavlja temelj moje strokovne in osebne rasti. Med drugim mi omogoča, da pri delu s klienti ostajam prisotna in pristna, pa tudi jasna in rahločutna sogovornica.</Text>

                <Text className="pt-6 text-center text-justify">
                Ob tem sem svoje strokovno znanje pridobila s magistrskim študijem psihologije in ga poglobila s 4-letno specializacijo iz sistemske psihoterapije na SFU Ljubljana. Svojo strokovno pot danes nadaljujem z doktorskim študijem na področju klinične psihologije in psihoterapije, znanje pa redno dopolnjujem z dodatnimi usposabljanji, ki so predstavljena spodaj.
                </Text>
              </div>
            </div>
          </div>  
        </div>
      </div>

      <div className='bg-tertiaryBg pl-4 pr-4'>
        <div className="lg:w-1/2 m-auto flex flex-col items-center align-middle pt-12 pb-24" >
          <div>
            <H2 className="pt-12 text-3xl" style={{color: "#6F3B44"}}>Strokovna pot</H2>
            <H3 className="pt-6">Akademska izobrazba</H3>
            <div className='flex flex-col w-full'>
              <ul className="list-disc p-6 self-start">
                <li className="text-base font-inter"><label className='font-bold'>Doktorski</label> študijski program Humanistika in družboslovje, znanstveno področje <label className='font-bold'>aplikativne psihološke študije</label> (Univerza v Ljubljani, Filozofska fakulteta, 2023 – danes)</li>
                <li className="text-base font-inter"><label className='font-bold'>Magisterij iz Psihologije</label> (Študijski program Clinical Psychology, University of Bergamo, Italija, 2017 – 2019)</li>
                <li className="text-base font-inter"><label className='font-bold'>Študijska izmenjava</label> (v okviru magistrskega študija Clinical Psychology, Fairleigh Dickinson University, ZDA, 2018 – 2019)</li>
                <li className="text-base font-inter"><label className='font-bold'>Diploma iz Biopsihologije</label> (FAMNIT, Univerza na Primorskem, 2013 – 2017)</li>
              </ul>
            </div>

            <H3 className="pt-6">Psihoterapevtsko izobraževanje in specializacija</H3>
            <div className='flex flex-col w-full'>
              <ul className="list-disc p-6 self-start">
              <li className="text-base font-inter">Podiplomska specializacija <label className='font-bold'>Sistemske psihoterapije</label> (Univerza Sigmunda Freuda Dunaj – podružnica Ljubljana, 2020 – 2026; <a href="https://www.drustvo-dsps.si/specializanti/" target="_blank" rel="noopener noreferrer" className="underline">Društvo za sistemsko psihoterapijo Slovenije</a>)</li>
              <li className="text-base font-inter">Psihoterapevtska propedevtika (Univerza Sigmunda Freuda Dunaj – podružnica Ljubljana, 2020 – 2021)</li>
              </ul>
            </div>

            <H3 className="pt-6">Dodatna terapevtska usposabljanja</H3>
            <div className='flex flex-col w-full'>
              <ul className="list-disc p-6 self-start">
                <li className="text-base font-inter">Celostno usposabljanje <label className='font-bold'>Gestalt igralne psihoterapije</label> za delo z otroki in mladostniki (Varuh otroških src, 2024). Znanja, pridobljena v tem usposabljanju, bogatijo mojo prakso z večjo odprtostjo za izkustveno učenje in kreativno izražanje.</li>
                <li className="text-base font-inter">
                <label className='font-bold'>Medicinska hipnoza</label> (pridobljen naziv terapevtke medicinske hipnoze, <a href="https://hipnoza-dmhs.si/user/spela.verbnik/" target="_blank" rel="noopener noreferrer" className="underline">Društvo za medicinsko hipnozo Slovenije</a>, 2017). To izobraževanje je bilo izhodišče za moje terapevtsko delo ter dragocen vpogled v načine, kako spomini, misli in prepričanja (so)bivajo v podzavesti in kakšen je njihov vpliv ter potencial za spremembo.
                </li>
              </ul>
            </div>

            <H3 className="pt-6">Nadaljnja strokovna izpopolnjevanja</H3>
            <div className='flex flex-col w-full'>
              <ul className="list-disc p-6 self-start">
                <li className="text-base font-inter">Sodobne raziskave vpliva in terapije travme ter stresa v družini – semestrski predmet (Univerza v Ljubljani – Teološka fakulteta, prof. dr. Robert Cvetek, 2025) </li>
                <li className="text-base font-inter">Raziskovanje sprememb v terapiji, superviziji in coachingu – semestrski predmet (Univerza v Ljubljani – Teološka fakulteta, prof. dr. Tomaž Erzar, 2024)</li>
                <li className="text-base font-inter">Starševska izgorelost: diagnostika in obravnava (Training Institute Psychology and Health, spletno izobraževanje, 2024)</li>
                <li className="text-base font-inter">Risanje drevesa v psihoterapiji (Heliodor Cvetko, 2023)</li>
                <li className="text-base font-inter">Pomoč z umetnostjo (poletna šola, University of Tallinn, Estonija, 2018)</li>
                <li className="text-base font-inter">Tehnike samohipnoze (strokovno usposabljanje, American Society of Clinical Hypnosis, ZDA, 2018)</li>
              </ul>
            </div>

            <H3 className="pt-6">Objave</H3>
            <div className='flex flex-col w-full'>
              <p className='text-lg pt-6 pb-2 text-primary color-primary font-playfair'>Znanstveni prispevki</p>
              <Citation>Poljanec, A. in Verbnik, Š. (2025). Duševno zdravje, zadovoljstvo z življenjem in navezanost oseb z naglušnostjo v Sloveniji. <i>
                 Kairos – Slovenska revija za psihoterapijo</i>, 19(1–2), 59–83.
              </Citation>
              <Citation>
              Verbnik, Š. in Možina, M. (2021). Skupni dejavniki v partnerski in družinski terapiji. 
              <i> Kairos – Slovenska revija za psihoterapijo</i>, 15(1–2), 151–189.
              </Citation>
              <p className='text-lg pt-6 pb-2 text-primary color-primary font-playfair'>Prispevek v zborniku</p>
              <Citation>Verbnik, Š. (2022). Skupni dejavniki v partnerski in družinski psihoterapiji. V A. 
                Poljanec in A. Štrukelj Kozina (ur.), 
                <i> Zbornik – 1. študijski dan SFU Ljubljana: Psihologija in psihoterapija z roko v roki</i> (str. 28–31). SFU Press Ljubljana.
              </Citation>
              <p className='text-lg pt-6 pb-2 text-primary color-primary font-playfair'>Strokovni in poljudno-strokovni spletni prispevki</p>
              <Citation>Verbnik, Š. (2021). <i>Sistemska psihoterapija in osredotočenost na vire v kontekstu kriznih situacij</i>. Blog SFU Ljubljana. Pridobljeno s https://www.sfu-ljubljana.si/sl/blog/sistemska-psihoterapija-osredotocenost-na-vire-v-kontekstu-kriznih-situacij</Citation>
              <Citation>
              Verbnik, Š. (2021). <i>Čuječnost kot (iz)vir moči</i>. Revija Študent / Student.si. Pridobljeno s https://www.student.si/izpostavljeno/novice-partnerjev/cujecnost-kot-izvir-moci/
              </Citation>

              <div className='flex justify-center align-middle pt-12  w-full'>
                <img className='w-1/3 md:w-[13%]' src="/assets/logo_filler_sage.svg" alt="" />
              </div>

              <Text className="text-base pt-12 text-left font-bold">Vse, kar sem doživljala, se učila in raziskovala, se zliva v moje psihoterapevtsko delo, da lahko kot zanesljiva sopotnica spremljam posameznika na poti osebnostne rasti. 
              </Text>
            </div>
          </div>
          
        </div>
      </div>
    </>
    
  );
}

export default About; 